import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SignUpPasswordComponent } from './components/sign-up-password/sign-up-password.component';
import { SignUpStepsComponent } from './components/sign-up-containers/sign-up-steps/sign-up-steps.component';
import { SharedModule } from '../shared/shared.module';
import { TableSettingsService } from '../../../../../src/app/website/shared/table-utils/table-settings.service';
import { SessionStoreService } from '../../../../../src/app/website/services/session-store.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ClientSharedModule } from '../shared/client-shared.module';
import { SignUpTermsAndConditionsComponent } from './components/sign-up-terms-and-conditions/sign-up-terms-and-conditions.component';
import { SignUpMobileAuthorisationComponent } from './components/sign-up-mobile-authorisation/sign-up-mobile-authorisation.component';
import { PasswordRequirementsModule } from '../shared/components/password-requirements/password-requirements.module';
import { AdvisorSharedModule } from '../../../../../src/app/website/shared/advisor-shared.module';

@NgModule({
  declarations: [
    SignUpPasswordComponent,
    SignUpStepsComponent,
    SignUpTermsAndConditionsComponent,
    SignUpMobileAuthorisationComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    ClientSharedModule,
    FormsModule,
    ReactiveFormsModule,
    PasswordRequirementsModule,
    AdvisorSharedModule
  ],
  providers: [TableSettingsService, SessionStoreService],
  exports: [
    SignUpPasswordComponent,
    SignUpStepsComponent,
    SignUpTermsAndConditionsComponent,
    SignUpMobileAuthorisationComponent
  ]
})
export class SignUpModule {}
